import React from 'react'
import { motion } from 'framer-motion'
import { cn } from '@/lib/utils'

interface GlassCardProps {
  children: React.ReactNode
  className?: string
  hover?: boolean
  animate?: boolean
}

const GlassCard: React.FC<GlassCardProps> = ({ 
  children, 
  className, 
  hover = false,
  animate = true 
}) => {
  return (
    <motion.div
      initial={animate ? { opacity: 0, y: 20 } : {}}
      animate={animate ? { opacity: 1, y: 0 } : {}}
      whileHover={hover ? { y: -4, scale: 1.02 } : {}}
      transition={{ duration: 0.3, ease: "easeOut" }}
      className={cn(
        "relative overflow-visible backdrop-blur-lg bg-white/10 dark:bg-gray-900/20",
        "border border-white/20 dark:border-gray-700/30",
        "rounded-2xl shadow-xl shadow-black/10",
        "before:absolute before:inset-0 before:rounded-2xl",
        "before:bg-gradient-to-br before:from-white/20 before:to-transparent",
        "before:opacity-50 before:pointer-events-none",
        hover && "cursor-pointer transition-all duration-300",
        className
      )}
    >
      <div className="relative z-10 p-6">
        {children}
      </div>
    </motion.div>
  )
}

export default GlassCard
